module.exports = __webpack_public_path__ + "static/img/pay-icon01-ov.6704da84.svg";